import React from 'react';
import { FaEnvelopeOpen, FaWhatsapp } from "react-icons/fa";
import { FaPhoneAlt } from 'react-icons/fa';
import { FaLandmark } from 'react-icons/fa';
import { FaEnvelope } from 'react-icons/fa';
import { CONTACT_INFO } from '../config/constants';
import AboutImg from '../assets/about.png';
import { FooterImage } from '../data/photos';

export default function Footer() {

  const address = CONTACT_INFO.address;
  const email = CONTACT_INFO.email;
  const phone = CONTACT_INFO.mainPhone;
  const phone2 = CONTACT_INFO.phone2;
  const phone3 = CONTACT_INFO.phone3;
  const phone4 = CONTACT_INFO.phone4;
  const whatsapp = CONTACT_INFO.mainWhatsappLink;

  return (

      <footer className="bg-[#03002b]  backdrop-blur-md border-t border-gray-200 shadow-inner pt-8 pb-2 mt-20 select-none">
      <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 gap-6 text-white md:grid-cols-3 md:gap-8 md:text-left text-center">
        <div>
          {/* <h3 className="text-2xl font-bold text-sky-600 mb-4 flex justify-center items-center gap-2 relative z-10 md:justify-start">
          <img src={Logo} alt="Ambulance Logo" className="h-6 w-auto" />
            Madeshwara Ambulance
          </h3> */}
          <h3 className="text-2xl font-bold text-sky-600 mb-4 flex justify-center items-center gap-2 relative z-10 md:justify-start">
          <img src={FooterImage} alt="Ambulance Logo" className="h-16 w-auto" />
            {/* Madeshwara Ambulance */}
          </h3>
          <p className="text-sm max-w-xs mx-auto md:mx-0">
            24/7 ambulance services with trained staff and equipped vehicles to provide trusted medical support when needed most.
          </p>
        </div>
        <div>
          <h4 className="text-xl font-semibold text-sky-600 mb-4">Quick Links</h4>
          <ul className="space-y-2">
            <li><a href="/" className="hover:text-sky-600 transition">Home</a></li>
            <li><a href="/about" className="hover:text-sky-600 transition">About</a></li>
            <li><a href="/services" className="hover:text-sky-600 transition">Services</a></li>
            <li><a href="/contact" className="hover:text-sky-600 transition">Contact</a></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xl font-semibold text-sky-600 mb-4">Contact Us</h4>
          <ul className="space-y-2 text-sm flex flex-col items-center md:items-start">

            <li className="mb-4 flex flex-col gap-2 items-center md:flex-row md:items-center space-y-1 md:space-y-0 md:space-x-2 text-center md:text-left">
              <FaLandmark className="text-white text-2xl" />
                {address}
            </li>

            <li className="flex flex-col gap-2 items-center md:flex-row md:items-center space-y-1 md:space-y-0 md:space-x-2 text-center md:text-left">
              <FaEnvelope className="text-white text-lg" aria-hidden="true" />
                {email}
            </li>

            <li className="flex flex-col gap-2 items-center md:flex-row md:items-center space-y-1 md:space-y-0 md:space-x-2 text-center md:text-left">
              <FaPhoneAlt className="text-white text-lg" />
              <a href={`tel:${phone}`} className="hover:text-sky-600 transition" target="_blank" rel="noopener noreferrer">
                +91 {phone}
              </a>
            </li>

            <li className="flex flex-col items-center md:flex-row md:items-center space-y-1 md:space-y-0 md:space-x-2 text-center md:text-left">
              {/* <FaPhoneAlt className="text-gray-600 text-lg" /> */}
              <a href={`tel:${phone2}`} className="px-9 hover:text-sky-600 transition" target="_blank" rel="noopener noreferrer">
                +91 {phone2}
              </a>
            </li>

            <li className="mb-4 flex flex-col items-center md:flex-row md:items-center space-y-1 md:space-y-0 md:space-x-2 text-center md:text-left">
              {/* <FaPhoneAlt className="text-gray-600 text-lg" /> */}
              <a href={`tel:${phone3}`} className="px-9 hover:text-sky-600 transition" target="_blank" rel="noopener noreferrer">
                +91 {phone3}
              </a>
            </li>

            <li className="mb-4 flex flex-col items-center md:flex-row md:items-center space-y-1 md:space-y-0 md:space-x-2 text-center md:text-left">
              {/* <FaPhoneAlt className="text-gray-600 text-lg" /> */}
              <a href={`tel:${phone4}`} className="px-9 hover:text-sky-600 transition" target="_blank" rel="noopener noreferrer">
                +91 {phone4}
              </a>
            </li>
            
            <li className="flex flex-col items-center md:flex-row md:items-center space-y-1 md:space-y-0 md:space-x-2 text-center md:text-left">
              <FaWhatsapp className="text-[#25D366] text-2xl" />
              <a href= {whatsapp} className="text-[#25D366] hover:text-sky-600 transition" target="_blank" rel="noopener noreferrer">
                Chat on WhatsApp
              </a>
            </li>

          </ul>
        </div>
      </div>
      <div className="text-center text-gray-400 text-sm mt-4 border-t border-gray-100 pt-4">
        © {new Date().getFullYear()} Madeshwara Ambulance. All rights reserved.
      </div>
    </footer>
  );
}
